import {Page, PageContent, Spacer} from 'components/Page'
import {styled} from '@mui/material'
import {
    useGetCurrentUserQuery,
    useGetPlannerActivitiesQuery,
    useI18n,
    useSaveUserMutation,
} from 'store/Store'
import PageTitle from 'components/Display/PageTitle'
import {Icons} from 'appearance'
import FormSettingsItem from './FormSettingsItem'
import {getDashboardPeriods} from 'services/utils/misc'
import SimpleSettingsItem from './SimpleSettingsItem'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import {removeUserPrefixes} from 'services/utils/apiUtils'
import useAddCreditCard from 'logic/Settings/useAddCreditCard'
import {useState} from 'react'
import {useDeviceDetect} from 'services/hooks'
import AppsIcon from '@mui/icons-material/Apps'
import {useGetPlannerCrmsQuery} from 'store/slices/api/crmsApi'
import ListSettingsItem from './ListSettingsItem'
import CrmsItem from './Crms/CrmsItem'

const Settings = () => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()
    useAddCreditCard()
    // const [searchParams, setSearchParams] = useSearchParams()
    // const [ccResponse, setCcResponse] = useState(null)

    const {today, monthAgo} = getDashboardPeriods()
    const [period, setPeriod] = useState({from: monthAgo, to: today})

    const {data: user, isLoading} = useGetCurrentUserQuery()
    const {data: activities} = useGetPlannerActivitiesQuery(period)
    const {data: crms} = useGetPlannerCrmsQuery()

    console.log('crms', crms)

    const onSelectPeriod = (value) => {
        setPeriod(value)
    }

    if (isLoading) {
        return <p>loading...</p>
    }

    return (
        <Page title={''}>
            <Content isMobile={isMobile}>
                <PageTitle
                    title={i18n.t('menu.settings')}
                    icon={Icons.Settings}
                    iconStyle={{width: 34, height: 34}}
                />

                <FormSettingsItem
                    isMobile={isMobile}
                    itemName="users"
                    item={{
                        ...user,
                        phone: removeUserPrefixes()(user?.phone),
                        id: removeUserPrefixes()(user?.id),
                    }}
                    allowEdit
                    photoFieldName="userPhoto"
                    readOnlyInputs={['id', 'phone']}
                    useSaveItemMutation={useSaveUserMutation}
                />

                <SimpleSettingsItem
                    isMobile={isMobile}
                    itemName="payments"
                    item={user}
                    Icon={CreditCardIcon}
                    useSaveItemMutation={useSaveUserMutation}
                    activities={activities}
                    onSelectPeriod={onSelectPeriod}
                />

                <ListSettingsItem
                    isMobile={isMobile}
                    itemName="crms"
                    items={crms?.crms}
                    Icon={AppsIcon}
                    itemComponent={(item) => <CrmsItem crm={item} />}
                    useSaveItemMutation={useSaveUserMutation}
                    activities={activities}
                    onSelectPeriod={onSelectPeriod}
                />

                <Spacer h={48} w={10} />
            </Content>
        </Page>
    )
}

export default Settings

const Content = styled(PageContent)`
    display: flex;
    flex-direction: column;
    gap: 36px;
    padding: 48px ${({isMobile}) => (isMobile ? 20 : 48)}px;
`
